import TIM from 'tim-js-sdk';

export async function createTim({
    userID,
    userSig,
    logLevel,
    listeners,
    appId,
    onReady
}: {
    userID?: string;
    userSig?: string;
    logLevel: number;
    appId: number;
    listeners?: Record<string, (event) => void>;
    onReady: (tim, event) => void;
}) {
    const tim = TIM.create({SDKAppID: appId});
    tim.setLogLevel(logLevel);
    tim.on(TIM.EVENT.SDK_READY, async function timReady(evt) {
        return onReady(tim, evt);
    });
    // 监听接收到消息的事件
    if (listeners) {
        for (const eventName in listeners) {
            tim.on(eventName, listeners[eventName]);
        }
    }
    if (userID && userSig) {
        await tim.login({userID, userSig}).catch(e => {
            console.warn('tim login error', e);
        });
    }
    return {
        tim
    };
}

export function sendCustomGroupMessage({
    tim,
    to,
    msg,
    command,
    uid,
    username
}: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tim: any;
    to: string;
    msg: string;
    command: number;
    uid: string;
    username: string;
}) {
    const customMessage = tim.createCustomMessage({
        to,
        conversationType: TIM.TYPES.CONV_GROUP,
        payload: {
            data: JSON.stringify({
                command: command,
                data: {
                    username: username,
                    uid: uid,
                    msg: msg
                }
            })
        }
    });
    return tim.sendMessage(customMessage);
}

export async function getGroupProfile({
    groupID,
    tim
}: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tim: any;
    groupID: string;
}) {
    const imResponse = await tim.getGroupProfile({groupID}).catch(imError => {
        console.warn('getGroupProfile error:', imError);
    });
    const groupInfo = imResponse?.data?.group.groupCustomField;
    if (imResponse?.code === 0 && groupInfo) {
        return groupInfo;
    }
}
